module.exports = __webpack_public_path__ + "img/batch_help.4e9a79bc.jpg";